import { useState, useEffect, useRef, RefObject } from "react";

export function useSplitResize(containerRef: RefObject<HTMLElement>, initial = 50) {
  const [split, setSplit] = useState(initial);
  const drag = useRef({ on: false, sx: 0, sp: initial });

  const onDividerMouseDown = (e: React.MouseEvent) => {
    drag.current = { on: true, sx: e.clientX, sp: split };
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";
  };

  useEffect(() => {
    const onMove = (e: MouseEvent) => {
      if (!drag.current.on || !containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const pct = ((e.clientX - rect.left) / rect.width) * 100;
      setSplit(Math.max(20, Math.min(80, pct)));
    };
    const onUp = () => {
      drag.current.on = false;
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
    return () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    };
  }, [containerRef]);

  return { split, onDividerMouseDown };
}
